import { ncbData, publicDataFetch } from '../../api';

const RSVP_TABLE = 'event_rsvps_1782000000';

/** Loads the signed-in person's own RSVPs. Returns { [eventId]: RSVP record }. */
export async function loadMyRsvps() {
  const res = await ncbData('read', RSVP_TABLE, {});
  if (res?.status !== 'success') {
    return { status: 'error', error: res?.error || 'Could not load RSVPs', map: {} };
  }

  const rows = Array.isArray(res?.data) ? res.data : [];
  const map = {};
  rows.forEach((row) => {
    const eventId = row?.event_id ?? '';
    if (eventId) {
      map[String(eventId)] = {
        id: row?.id ?? null,
        event_id: String(eventId),
        memorial_id: row?.memorial_id ?? '',
        event_title: row?.event_title ?? '',
        event_date: row?.event_date ?? '',
        status: row?.status ?? '',
      };
    }
  });
  return { status: 'success', map };
}

/** Creates or updates the person's RSVP for one event. */
export async function saveRsvp({ event, memorial, status, existing }) {
  const now = new Date().toISOString();

  if (existing?.id !== undefined && existing?.id !== null) {
    return ncbData('update', `${RSVP_TABLE}/${existing.id}`, { status, updated_at: now });
  }

  return ncbData('create', RSVP_TABLE, {
    event_id: String(event?.id ?? ''),
    memorial_id: String(memorial?.id ?? ''),
    event_title: event?.title ?? '',
    event_date: event?.date ? String(event.date) : '',
    status,
    created_at: now,
    updated_at: now,
  });
}

/** Removes the person's RSVP so they can choose again. */
export async function clearRsvp(existing) {
  if (existing?.id === undefined || existing?.id === null) {
    return { status: 'success', data: null };
  }
  return ncbData('delete', `${RSVP_TABLE}/${existing.id}`, {});
}

/** Public event waitlist submission, stored without requiring an account. */
export async function submitEventWaitlist({ event, memorial, guestName, guestEmail }) {
  const now = new Date().toISOString();

  return publicDataFetch(`create/${RSVP_TABLE}`, {
    method: 'POST',
    body: JSON.stringify({
      event_id: String(event?.id ?? ''),
      memorial_id: String(memorial?.id ?? ''),
      event_title: event?.title ?? '',
      event_date: event?.date ? String(event.date) : '',
      status: 'waitlist',
      guest_name: guestName.trim(),
      guest_email: guestEmail.trim(),
      created_at: now,
      updated_at: now,
    }),
  });
}